// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BriefRow-module__font-s-10___mDT0F {
  font-size: 10px !important;
}

.BriefRow-module__font-s-12___tZuSx {
  font-size: 12px !important;
}

.BriefRow-module__font-s-13___OaNe3 {
  font-size: 13px !important;
}

.BriefRow-module__font-s-14___C9xUf {
  font-size: 14px !important;
}

.BriefRow-module__font-s-15___zfMOg {
  font-size: 15px !important;
}

.BriefRow-module__font-s-16___ijglk {
  font-size: 16px !important;
}

.BriefRow-module__font-s-18___lmzJf {
  font-size: 18px !important;
}

.BriefRow-module__font-s-20___vxWqQ {
  font-size: 20px !important;
}

.BriefRow-module__font-s-22___gx6W8 {
  font-size: 22px !important;
}

.BriefRow-module__font-s-28___gdYw5 {
  font-size: 28px !important;
}

.BriefRow-module__font-w-400___H6R8u {
  font-weight: 400 !important;
}

.BriefRow-module__font-w-500___JoB8u {
  font-weight: 500 !important;
}

.BriefRow-module__font-w-600___HD7Gf {
  font-weight: 600 !important;
}

.BriefRow-module__font-w-700___oOnGm {
  font-weight: 700 !important;
}

.BriefRow-module__p-5___TOECj {
  padding: 5px !important;
}

.BriefRow-module__p-12___JT8MI {
  padding: 12px !important;
}

.BriefRow-module__p-16___yNOGv {
  padding: 16px !important;
}

.BriefRow-module__p-30___lvPWu {
  padding: 30px !important;
}

.BriefRow-module__p-b-0___cCd1Q {
  padding-bottom: 0 !important;
}

.BriefRow-module__p-b-5___aS24R {
  padding-bottom: 5px !important;
}

.BriefRow-module__p-b-10___AYR_Z {
  padding-bottom: 10px !important;
}

.BriefRow-module__p-b-12___MavdX {
  padding-bottom: 12px !important;
}

.BriefRow-module__p-b-16___YUwdU {
  padding-bottom: 16px !important;
}

.BriefRow-module__p-b-18___mLdVh {
  padding-bottom: 18px !important;
}

.BriefRow-module__p-b-20___AZ4_U {
  padding-bottom: 20px !important;
}

.BriefRow-module__p-b-25___Jj4ow {
  padding-bottom: 25px !important;
}

.BriefRow-module__p-b-30___WhSlo {
  padding-bottom: 30px !important;
}

.BriefRow-module__p-b-50___eXCrX {
  padding-bottom: 50px !important;
}

.BriefRow-module__p-t-0___frc15 {
  padding-top: 0 !important;
}

.BriefRow-module__p-t-12___QpsOP {
  padding-top: 12px !important;
}

.BriefRow-module__p-t-16___IYOES {
  padding-top: 16px !important;
}

.BriefRow-module__p-t-18___z_KjI {
  padding-top: 18px !important;
}

.BriefRow-module__p-t-20___jVlHI {
  padding-top: 20px !important;
}

.BriefRow-module__p-t-30___qldeo {
  padding-top: 30px !important;
}

.BriefRow-module__p-t-40___Liy98 {
  padding-top: 40px !important;
}

.BriefRow-module__p-t-50___S_Dq3 {
  padding-top: 50px !important;
}

.BriefRow-module__p-l-20___FdySl {
  padding-left: 20px !important;
}

.BriefRow-module__p-l-30___nVl9y {
  padding-left: 30px !important;
}

.BriefRow-module__p-l-40___DQ4Rj {
  padding-left: 40px !important;
}

.BriefRow-module__p-r-16___bRWLT {
  padding-right: 16px !important;
}

.BriefRow-module__p-r-20___Goieg {
  padding-right: 20px !important;
}

.BriefRow-module__p-r-30___PHA2a {
  padding-right: 30px !important;
}

.BriefRow-module__p-r-50___csBu6 {
  padding-right: 50px !important;
}

.BriefRow-module__p-r-60___bSGUM {
  padding-right: 60px !important;
}

.BriefRow-module__m-b-1___Sfs0Y {
  margin-bottom: 1px !important;
}

.BriefRow-module__m-b-2___BACvU {
  margin-bottom: 2px !important;
}

.BriefRow-module__m-b-6___EknNw {
  margin-bottom: 6px !important;
}

.BriefRow-module__m-b-8___sIjHz {
  margin-bottom: 8px !important;
}

.BriefRow-module__m-b-10___KmanS {
  margin-bottom: 10px !important;
}

.BriefRow-module__m-b-14___qsWHB {
  margin-bottom: 14px !important;
}

.BriefRow-module__m-b-16___eNaai {
  margin-bottom: 16px !important;
}

.BriefRow-module__m-b-20___NfOUh {
  margin-bottom: 20px !important;
}

.BriefRow-module__m-b-22___NIx21 {
  margin-bottom: 22px !important;
}

.BriefRow-module__m-b-24___WJ3Hy {
  margin-bottom: 24px !important;
}

.BriefRow-module__m-b-30___wXOTa {
  margin-bottom: 30px !important;
}

.BriefRow-module__m-b-32___XsaFm {
  margin-bottom: 32px !important;
}

.BriefRow-module__m-b-40___bxZx7 {
  margin-bottom: 40px !important;
}

.BriefRow-module__m-t-2___I8ZFk {
  margin-top: 2px !important;
}

.BriefRow-module__m-t-3___RRulM {
  margin-top: 3px !important;
}

.BriefRow-module__m-t-4___cISgm {
  margin-top: 4px !important;
}

.BriefRow-module__m-t-5___GCw3J {
  margin-top: 5px !important;
}

.BriefRow-module__m-t-8___Ud2_V {
  margin-top: 8px !important;
}

.BriefRow-module__m-t-10___yVIz4 {
  margin-top: 10px !important;
}

.BriefRow-module__m-t-15___ZVxbY {
  margin-top: 15px !important;
}

.BriefRow-module__m-t-16___Tlo4Q {
  margin-top: 16px !important;
}

.BriefRow-module__m-t-20___u8EYI {
  margin-top: 20px !important;
}

.BriefRow-module__m-t-22___uUs11 {
  margin-top: 22px !important;
}

.BriefRow-module__m-t-30___iN_uk {
  margin-top: 30px !important;
}

.BriefRow-module__m-t-32___RQKEW {
  margin-top: 32px !important;
}

.BriefRow-module__m-l-auto___COkNM {
  margin-left: auto !important;
}

.BriefRow-module__m-l-4___yYV6D {
  margin-left: 4px !important;
}

.BriefRow-module__m-l-5___eFjhG {
  margin-left: 5px !important;
}

.BriefRow-module__m-l-6___oxrHO {
  margin-left: 6px !important;
}

.BriefRow-module__m-l-8___tznJv {
  margin-left: 8px !important;
}

.BriefRow-module__m-l-10___dKGw7 {
  margin-left: 10px !important;
}

.BriefRow-module__m-l-16___mrtMm {
  margin-left: 16px !important;
}

.BriefRow-module__m-l-20___IG4n5 {
  margin-left: 20px !important;
}

.BriefRow-module__m-l-24___phO2I {
  margin-left: 24px !important;
}

.BriefRow-module__m-l-30___rUYGT {
  margin-left: 30px !important;
}

.BriefRow-module__m-l-35___JFGAL {
  margin-left: 35px !important;
}

.BriefRow-module__m-l-40___VL1H9 {
  margin-left: 40px !important;
}

.BriefRow-module__m-r-8___lYVzb {
  margin-right: 8px !important;
}

.BriefRow-module__m-r-10___eZ5fP {
  margin-right: 10px !important;
}

.BriefRow-module__m-r-16___LmObO {
  margin-right: 16px !important;
}

.BriefRow-module__m-r-20___gF3xw {
  margin-right: 20px !important;
}

.BriefRow-module__m-r-24___w8cDH {
  margin-right: 24px !important;
}

.BriefRow-module__m-r-30___mK5i0 {
  margin-right: 30px !important;
}

.BriefRow-module__m-r-40___tOWR5 {
  margin-right: 40px !important;
}

.BriefRow-module__border-r-3___wJCbs {
  border-radius: 3px !important;
}

.BriefRow-module__border-r-4___kBdnf {
  border-radius: 4px !important;
}

.BriefRow-module__border-r-6___oEIap {
  border-radius: 6px !important;
}

.BriefRow-module__border-r-10___NEryV {
  border-radius: 10px !important;
}

.BriefRow-module__border-r-12___KCq4c {
  border-radius: 12px !important;
}

.BriefRow-module__border-r-16___z4gi6 {
  border-radius: 16px !important;
}

.BriefRow-module__border-r-50___VUEgJ {
  border-radius: 50% !important;
}

.BriefRow-module__primary-border___zYfN1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefRow-module__primary-border-b___belm2 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefRow-module__primary-border-t___nBimR {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefRow-module__primary-border-l___VqNmY {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefRow-module__primary-border-r___FivxD {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefRow-module__secondary-border___TltwY {
  border: 1px solid #637768;
}

.BriefRow-module__secondary-border-b___krWsQ {
  border-bottom: 1px solid #637768;
}

.BriefRow-module__secondary-border-t___OGeVz {
  border-top: 1px solid #637768;
}

.BriefRow-module__secondary-border-l___m3Rq5 {
  border-left: 1px solid #637768;
}

.BriefRow-module__secondary-border-r___kuqu2 {
  border-right: 1px solid #637768;
}

.BriefRow-module__gap-0___zBoOs {
  gap: 0 !important;
}

.BriefRow-module__gap-2___Wv1zs {
  gap: 2px !important;
}

.BriefRow-module__gap-4___sn4LJ {
  gap: 4px !important;
}

.BriefRow-module__gap-5___rypHD {
  gap: 5px !important;
}

.BriefRow-module__gap-6___c6e5b {
  gap: 6px !important;
}

.BriefRow-module__gap-8___AdNjC {
  gap: 8px !important;
}

.BriefRow-module__gap-10___gQzKs {
  gap: 10px !important;
}

.BriefRow-module__gap-12___tT2M_ {
  gap: 12px !important;
}

.BriefRow-module__gap-14___uyUJk {
  gap: 14px !important;
}

.BriefRow-module__gap-16___jukJX {
  gap: 16px !important;
}

.BriefRow-module__gap-18___qMZNy {
  gap: 18px !important;
}

.BriefRow-module__gap-20___zfNxP {
  gap: 20px !important;
}

.BriefRow-module__gap-24____ebcr {
  gap: 24px !important;
}

.BriefRow-module__gap-26___qT5kA {
  gap: 26px !important;
}

.BriefRow-module__gap-30___wg9Sl {
  gap: 30px !important;
}

.BriefRow-module__gap-32___zXbMZ {
  gap: 32px !important;
}

.BriefRow-module__gap-40___RkMNC {
  gap: 40px !important;
}

.BriefRow-module__gap-50___aFMR5 {
  gap: 50px !important;
}

.BriefRow-module__flex-1___gkNvH {
  flex: 1;
}

.BriefRow-module__flex-none___q7YpG {
  flex: none !important;
}

.BriefRow-module__flex-column___GcJ7F {
  display: flex;
  flex-direction: column !important;
}

.BriefRow-module__flex-row___gdwu7 {
  display: flex;
  flex-direction: row !important;
}

.BriefRow-module__vertically-centered___Ik5Op {
  display: flex;
  align-items: center !important;
}

.BriefRow-module__horizontally-centered___eu3QL {
  display: flex;
  justify-content: center !important;
}

.BriefRow-module__horizontally-end___MZ5zA {
  display: flex;
  justify-content: end !important;
}

.BriefRow-module__vertically-start___FmnF3 {
  display: flex;
  align-items: start !important;
}

.BriefRow-module__space-between___boVMv {
  display: flex;
  justify-content: space-between !important;
}

.BriefRow-module__flex-wrap___k5mQ8 {
  flex-wrap: wrap !important;
}

.BriefRow-module__height-100___uA2eH {
  height: 100%;
}

.BriefRow-module__width-50___jWagJ {
  width: 50% !important;
}

.BriefRow-module__width-100___YN29c {
  width: 100%;
}

.BriefRow-module__cursor-pointer___H8My6 {
  cursor: pointer;
}

.BriefRow-module__cursor-not-allowed___n8jNf {
  cursor: not-allowed !important;
}

.BriefRow-module__absolute-centered___znAro {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BriefRow-module__absolute___sSSDV {
  position: absolute;
}

.BriefRow-module__relative___QfKJn {
  position: relative;
}

.BriefRow-module__fixed___cQ5cZ {
  position: fixed;
}

.BriefRow-module__visible___Aju0h {
  opacity: 1;
}

.BriefRow-module__invisible___qoivk {
  opacity: 0;
}

.BriefRow-module__col-90___tgo_F {
  width: 90% !important;
}

.BriefRow-module__col-auto___T1bIf {
  width: auto !important;
}

.BriefRow-module__medical-tabs___tXv9k {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BriefRow-module__medical-table-new___hPWph {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BriefRow-module__medical-table-new___hPWph:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BriefRow-module__medical-table-new___hPWph::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BriefRow-module__medical-table-new___hPWph::-webkit-scrollbar-track {
  display: none;
}
.BriefRow-module__medical-table-new___hPWph.BriefRow-module__no-pagination___gpIWz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BriefRow-module__medical-table-new___hPWph.BriefRow-module__no-pagination___gpIWz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BriefRow-module__medical-table-new___hPWph.BriefRow-module__no-pagination___gpIWz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BriefRow-module__medical-table-new___hPWph.BriefRow-module__no-pagination___gpIWz::-webkit-scrollbar-track {
  display: none;
}

.BriefRow-module__medical-table-empty___aG3XA {
  padding: 14px 40px !important;
}

.BriefRow-module__icon-btn___lUyqR {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BriefRow-module__search-icon___nATI4 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BriefRow-module__disable-select___X9_M1 {
  user-select: none;
}

.BriefRow-module__break-word___bmQKm {
  word-break: break-word;
}

.BriefRow-module__popup-clear-btn___Anl4a {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BriefRow-module__scroll-m-b-20___oFHey {
  scroll-margin-bottom: 20px;
}

.BriefRow-module__card___sE09l {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
}

.BriefRow-module__alert___NCXjC {
  border-color: rgba(185, 28, 28, 0.4);
}

.BriefRow-module__current___LRPob {
  border-color: #18181b;
  box-shadow: 0 0 0 1px #18181b;
}

.BriefRow-module__done___CWfQs {
  border-color: #bbf7d0;
}

.BriefRow-module__warn___Bf48W {
  border-color: #fde68a;
}

.BriefRow-module__body___HbvIw {
  display: flex;
  min-width: 0;
  flex-direction: column;
  font-size: 15px;
  color: #18181b;
}
.BriefRow-module__body___HbvIw > * + * {
  border-top: 1px solid #e4e4e7;
}

.BriefRow-module__padded___OWWwz > * {
  padding: 10px 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/Visit/BriefRow.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,oCAAA;AA8pBF;;AA3pBA;EACE,qBAAA;EACA,6BAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,6BAAA;AA8pBJ;;AA1pBA;EACE,kBAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.card {\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid $hairline;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.alert {\n  border-color: rgba(185, 28, 28, 0.4);\n}\n\n.current {\n  border-color: #18181b;\n  box-shadow: 0 0 0 1px #18181b;\n}\n\n.done {\n  border-color: #bbf7d0;\n}\n\n.warn {\n  border-color: #fde68a;\n}\n\n.body {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  font-size: 15px;\n  color: #18181b;\n\n  > * + * {\n    border-top: 1px solid $hairline;\n  }\n}\n\n.padded > * {\n  padding: 10px 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BriefRow-module__font-s-10___mDT0F`,
	"fontS12": `BriefRow-module__font-s-12___tZuSx`,
	"fontS13": `BriefRow-module__font-s-13___OaNe3`,
	"fontS14": `BriefRow-module__font-s-14___C9xUf`,
	"fontS15": `BriefRow-module__font-s-15___zfMOg`,
	"fontS16": `BriefRow-module__font-s-16___ijglk`,
	"fontS18": `BriefRow-module__font-s-18___lmzJf`,
	"fontS20": `BriefRow-module__font-s-20___vxWqQ`,
	"fontS22": `BriefRow-module__font-s-22___gx6W8`,
	"fontS28": `BriefRow-module__font-s-28___gdYw5`,
	"fontW400": `BriefRow-module__font-w-400___H6R8u`,
	"fontW500": `BriefRow-module__font-w-500___JoB8u`,
	"fontW600": `BriefRow-module__font-w-600___HD7Gf`,
	"fontW700": `BriefRow-module__font-w-700___oOnGm`,
	"p5": `BriefRow-module__p-5___TOECj`,
	"p12": `BriefRow-module__p-12___JT8MI`,
	"p16": `BriefRow-module__p-16___yNOGv`,
	"p30": `BriefRow-module__p-30___lvPWu`,
	"pB0": `BriefRow-module__p-b-0___cCd1Q`,
	"pB5": `BriefRow-module__p-b-5___aS24R`,
	"pB10": `BriefRow-module__p-b-10___AYR_Z`,
	"pB12": `BriefRow-module__p-b-12___MavdX`,
	"pB16": `BriefRow-module__p-b-16___YUwdU`,
	"pB18": `BriefRow-module__p-b-18___mLdVh`,
	"pB20": `BriefRow-module__p-b-20___AZ4_U`,
	"pB25": `BriefRow-module__p-b-25___Jj4ow`,
	"pB30": `BriefRow-module__p-b-30___WhSlo`,
	"pB50": `BriefRow-module__p-b-50___eXCrX`,
	"pT0": `BriefRow-module__p-t-0___frc15`,
	"pT12": `BriefRow-module__p-t-12___QpsOP`,
	"pT16": `BriefRow-module__p-t-16___IYOES`,
	"pT18": `BriefRow-module__p-t-18___z_KjI`,
	"pT20": `BriefRow-module__p-t-20___jVlHI`,
	"pT30": `BriefRow-module__p-t-30___qldeo`,
	"pT40": `BriefRow-module__p-t-40___Liy98`,
	"pT50": `BriefRow-module__p-t-50___S_Dq3`,
	"pL20": `BriefRow-module__p-l-20___FdySl`,
	"pL30": `BriefRow-module__p-l-30___nVl9y`,
	"pL40": `BriefRow-module__p-l-40___DQ4Rj`,
	"pR16": `BriefRow-module__p-r-16___bRWLT`,
	"pR20": `BriefRow-module__p-r-20___Goieg`,
	"pR30": `BriefRow-module__p-r-30___PHA2a`,
	"pR50": `BriefRow-module__p-r-50___csBu6`,
	"pR60": `BriefRow-module__p-r-60___bSGUM`,
	"mB1": `BriefRow-module__m-b-1___Sfs0Y`,
	"mB2": `BriefRow-module__m-b-2___BACvU`,
	"mB6": `BriefRow-module__m-b-6___EknNw`,
	"mB8": `BriefRow-module__m-b-8___sIjHz`,
	"mB10": `BriefRow-module__m-b-10___KmanS`,
	"mB14": `BriefRow-module__m-b-14___qsWHB`,
	"mB16": `BriefRow-module__m-b-16___eNaai`,
	"mB20": `BriefRow-module__m-b-20___NfOUh`,
	"mB22": `BriefRow-module__m-b-22___NIx21`,
	"mB24": `BriefRow-module__m-b-24___WJ3Hy`,
	"mB30": `BriefRow-module__m-b-30___wXOTa`,
	"mB32": `BriefRow-module__m-b-32___XsaFm`,
	"mB40": `BriefRow-module__m-b-40___bxZx7`,
	"mT2": `BriefRow-module__m-t-2___I8ZFk`,
	"mT3": `BriefRow-module__m-t-3___RRulM`,
	"mT4": `BriefRow-module__m-t-4___cISgm`,
	"mT5": `BriefRow-module__m-t-5___GCw3J`,
	"mT8": `BriefRow-module__m-t-8___Ud2_V`,
	"mT10": `BriefRow-module__m-t-10___yVIz4`,
	"mT15": `BriefRow-module__m-t-15___ZVxbY`,
	"mT16": `BriefRow-module__m-t-16___Tlo4Q`,
	"mT20": `BriefRow-module__m-t-20___u8EYI`,
	"mT22": `BriefRow-module__m-t-22___uUs11`,
	"mT30": `BriefRow-module__m-t-30___iN_uk`,
	"mT32": `BriefRow-module__m-t-32___RQKEW`,
	"mLAuto": `BriefRow-module__m-l-auto___COkNM`,
	"mL4": `BriefRow-module__m-l-4___yYV6D`,
	"mL5": `BriefRow-module__m-l-5___eFjhG`,
	"mL6": `BriefRow-module__m-l-6___oxrHO`,
	"mL8": `BriefRow-module__m-l-8___tznJv`,
	"mL10": `BriefRow-module__m-l-10___dKGw7`,
	"mL16": `BriefRow-module__m-l-16___mrtMm`,
	"mL20": `BriefRow-module__m-l-20___IG4n5`,
	"mL24": `BriefRow-module__m-l-24___phO2I`,
	"mL30": `BriefRow-module__m-l-30___rUYGT`,
	"mL35": `BriefRow-module__m-l-35___JFGAL`,
	"mL40": `BriefRow-module__m-l-40___VL1H9`,
	"mR8": `BriefRow-module__m-r-8___lYVzb`,
	"mR10": `BriefRow-module__m-r-10___eZ5fP`,
	"mR16": `BriefRow-module__m-r-16___LmObO`,
	"mR20": `BriefRow-module__m-r-20___gF3xw`,
	"mR24": `BriefRow-module__m-r-24___w8cDH`,
	"mR30": `BriefRow-module__m-r-30___mK5i0`,
	"mR40": `BriefRow-module__m-r-40___tOWR5`,
	"borderR3": `BriefRow-module__border-r-3___wJCbs`,
	"borderR4": `BriefRow-module__border-r-4___kBdnf`,
	"borderR6": `BriefRow-module__border-r-6___oEIap`,
	"borderR10": `BriefRow-module__border-r-10___NEryV`,
	"borderR12": `BriefRow-module__border-r-12___KCq4c`,
	"borderR16": `BriefRow-module__border-r-16___z4gi6`,
	"borderR50": `BriefRow-module__border-r-50___VUEgJ`,
	"primaryBorder": `BriefRow-module__primary-border___zYfN1`,
	"primaryBorderB": `BriefRow-module__primary-border-b___belm2`,
	"primaryBorderT": `BriefRow-module__primary-border-t___nBimR`,
	"primaryBorderL": `BriefRow-module__primary-border-l___VqNmY`,
	"primaryBorderR": `BriefRow-module__primary-border-r___FivxD`,
	"secondaryBorder": `BriefRow-module__secondary-border___TltwY`,
	"secondaryBorderB": `BriefRow-module__secondary-border-b___krWsQ`,
	"secondaryBorderT": `BriefRow-module__secondary-border-t___OGeVz`,
	"secondaryBorderL": `BriefRow-module__secondary-border-l___m3Rq5`,
	"secondaryBorderR": `BriefRow-module__secondary-border-r___kuqu2`,
	"gap0": `BriefRow-module__gap-0___zBoOs`,
	"gap2": `BriefRow-module__gap-2___Wv1zs`,
	"gap4": `BriefRow-module__gap-4___sn4LJ`,
	"gap5": `BriefRow-module__gap-5___rypHD`,
	"gap6": `BriefRow-module__gap-6___c6e5b`,
	"gap8": `BriefRow-module__gap-8___AdNjC`,
	"gap10": `BriefRow-module__gap-10___gQzKs`,
	"gap12": `BriefRow-module__gap-12___tT2M_`,
	"gap14": `BriefRow-module__gap-14___uyUJk`,
	"gap16": `BriefRow-module__gap-16___jukJX`,
	"gap18": `BriefRow-module__gap-18___qMZNy`,
	"gap20": `BriefRow-module__gap-20___zfNxP`,
	"gap24": `BriefRow-module__gap-24____ebcr`,
	"gap26": `BriefRow-module__gap-26___qT5kA`,
	"gap30": `BriefRow-module__gap-30___wg9Sl`,
	"gap32": `BriefRow-module__gap-32___zXbMZ`,
	"gap40": `BriefRow-module__gap-40___RkMNC`,
	"gap50": `BriefRow-module__gap-50___aFMR5`,
	"flex1": `BriefRow-module__flex-1___gkNvH`,
	"flexNone": `BriefRow-module__flex-none___q7YpG`,
	"flexColumn": `BriefRow-module__flex-column___GcJ7F`,
	"flexRow": `BriefRow-module__flex-row___gdwu7`,
	"verticallyCentered": `BriefRow-module__vertically-centered___Ik5Op`,
	"horizontallyCentered": `BriefRow-module__horizontally-centered___eu3QL`,
	"horizontallyEnd": `BriefRow-module__horizontally-end___MZ5zA`,
	"verticallyStart": `BriefRow-module__vertically-start___FmnF3`,
	"spaceBetween": `BriefRow-module__space-between___boVMv`,
	"flexWrap": `BriefRow-module__flex-wrap___k5mQ8`,
	"height100": `BriefRow-module__height-100___uA2eH`,
	"width50": `BriefRow-module__width-50___jWagJ`,
	"width100": `BriefRow-module__width-100___YN29c`,
	"cursorPointer": `BriefRow-module__cursor-pointer___H8My6`,
	"cursorNotAllowed": `BriefRow-module__cursor-not-allowed___n8jNf`,
	"absoluteCentered": `BriefRow-module__absolute-centered___znAro`,
	"absolute": `BriefRow-module__absolute___sSSDV`,
	"relative": `BriefRow-module__relative___QfKJn`,
	"fixed": `BriefRow-module__fixed___cQ5cZ`,
	"visible": `BriefRow-module__visible___Aju0h`,
	"invisible": `BriefRow-module__invisible___qoivk`,
	"col90": `BriefRow-module__col-90___tgo_F`,
	"colAuto": `BriefRow-module__col-auto___T1bIf`,
	"medicalTabs": `BriefRow-module__medical-tabs___tXv9k`,
	"medicalTableNew": `BriefRow-module__medical-table-new___hPWph`,
	"noPagination": `BriefRow-module__no-pagination___gpIWz`,
	"medicalTableEmpty": `BriefRow-module__medical-table-empty___aG3XA`,
	"iconBtn": `BriefRow-module__icon-btn___lUyqR`,
	"searchIcon": `BriefRow-module__search-icon___nATI4`,
	"disableSelect": `BriefRow-module__disable-select___X9_M1`,
	"breakWord": `BriefRow-module__break-word___bmQKm`,
	"popupClearBtn": `BriefRow-module__popup-clear-btn___Anl4a`,
	"scrollMB20": `BriefRow-module__scroll-m-b-20___oFHey`,
	"card": `BriefRow-module__card___sE09l`,
	"alert": `BriefRow-module__alert___NCXjC`,
	"current": `BriefRow-module__current___LRPob`,
	"done": `BriefRow-module__done___CWfQs`,
	"warn": `BriefRow-module__warn___Bf48W`,
	"body": `BriefRow-module__body___HbvIw`,
	"padded": `BriefRow-module__padded___OWWwz`
};
module.exports = ___CSS_LOADER_EXPORT___;
